import { render, staticRenderFns } from "./TextResponse.vue?vue&type=template&id=55ac2c6a&scoped=true&"
import script from "./TextResponse.vue?vue&type=script&lang=js&"
export * from "./TextResponse.vue?vue&type=script&lang=js&"
import style0 from "./TextResponse.vue?vue&type=style&index=0&id=55ac2c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac2c6a",
  null
  
)

export default component.exports